import {ShortCargo} from "~/apps/packages/cargos/queries";
import {useCargoList} from "~/apps/packages/cargos/hooks";
import {findScrollableNode, useBottomScrollListener} from "~/lib/useBottomScrollListener";
import {useEffect} from "react";
import {useHistory} from "react-router-dom";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";
import {Box, List, ListItem} from "@mui/material";
import {CargoListItem} from "~/apps/packages/cargos/components/CargoList/CargoListItem";


export type CargoListProps = {
    onLoading?: (loading: boolean) => any
    onChange?: (pageInfo: { count: number }) => any
    statuses?: ShortCargo["status"][]
    dateFrom?: Date
    dateTo?: Date
    query?: string
}

export const CargoList = (props: CargoListProps) => {
    const {onLoading, onChange, statuses, query, dateFrom, dateTo} = props;
    const history = useHistory();
    const {data, loading, canFetchMore, fetchMore} = useCargoList({
        dateTo: dateTo,
        dateFrom: dateFrom,
        query: query,
        status: statuses,
    });

    const setScrollNode = useBottomScrollListener(() => {
        fetchMore();
    }, 50, 100, false);

    useEffect(() => {
        if (data) {
            onChange && onChange({count: data.length || 0});
        }
    }, [data]);

    useEffect(() => {
        onLoading && onLoading(loading);
    }, [loading]);

    const handleItemClick = (item: { id: string }) => {
        history.push(`/${encodeURI(item.id)}`);
    }

    const handleRef = (node) => {
        setScrollNode(findScrollableNode(node));
    }

    return (
        <LoadingBox isInitialLoading={data == undefined} loading={loading} empty={data?.length == 0} placeholder={canFetchMore}>
            {data?.length > 0 && (
                <List ref={handleRef}>
                    {data?.map((item) => (
                        <ListItem onClick={() => handleItemClick(item)} key={`${item.id}`}>
                            <CargoListItem cargo={item}/>
                        </ListItem>
                    ))}
                </List>
            )}
        </LoadingBox>
    )
}